import { Injectable, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { TimerObservable } from 'rxjs/observable/TimerObservable';

import { Observable } from 'rxjs/Observable';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';

import 'rxjs/add/operator/timeout';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import { CookieService } from 'app/services/cookie.service';
import { ConstantsService } from 'app/services/constants-service';
import { ObservableRequestService } from 'app/services/observable-request.service';

import { environment } from 'environments/environment';

import { SessionExpiredComponent } from 'app/shared/components/sessionexpired/session-expired.component';

/**
 * Service to logout the user when the Idle Time expires.
 */
@Injectable()
export class UserIdleService {
  private subscription: Subscription;
  private dialogRef: MdDialogRef<any>;

  viewContainerRef: ViewContainerRef;

  constructor(
    private cookieService: CookieService,
    private requestService: ObservableRequestService,
    private dialog: MdDialog) { }

  verifySessionValidity(sessionId: string): Observable<any> {
    return this.requestService
      .getRequest(ConstantsService.VERIFY_SESSION + sessionId);
  }

  showSessionExpiredPopup() {
    // Stop session verification timer
    this.subscription.unsubscribe();

    const config = new MdDialogConfig();
    config.disableClose = true;
    config.viewContainerRef = this.viewContainerRef;
    this.dialogRef = this.dialog.open(SessionExpiredComponent, config);
  }

  startSessionKeepAliveWatcher() {
    // 15 minutes on prod, 1 minute on dev
    const interval = environment.isDevelopmentEnv ? (1000 * 60 * 1) : (1000 * 60 * 15);

    const timer = TimerObservable.create(interval, interval);
    this.subscription = timer.subscribe(t => {
      const sessionId = this.cookieService.get(ConstantsService.COOKIE_SESSION_ID);

      this.verifySessionValidity(sessionId).subscribe(
        data => {
          if ((data.flagResult && data.arrResult.status) && data.message.trim() === '') {
            return data.flagResult && data.arrResult.status;
          } else {
            this.showSessionExpiredPopup();
          }
        },
        error => {
          if (error.status !== 0) {
            // Could be handy for debugging to determine why sessions timeout, please leave it here
            console.error(error); // tslint:disable-line

            // error status 0 means connection timeout
            this.showSessionExpiredPopup();
          }
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/user-idle.service.ts